import React, {useEffect} from 'react'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {Toolbar} from './components/toolbar/Toolbar'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {MasterInit} from './MasterInit'
import {PageDataProvider} from './core'
import {
  DrawerMessenger,
  ExploreMain,
  ActivityDrawer,
  Main,
  InviteUsers,
  UpgradePlan,
} from '../partials'
import {PermissionsClient} from '../../app/infrastracture/api/PermissionsClient'
import * as auth from '../../app/modules/auth/redux/AuthRedux'
import {shallowEqual, useDispatch, useSelector} from 'react-redux'
import {AccountSettingsClient} from '../../app/infrastracture/api/AccountSettingsClient'
import {RootState} from '../../setup'
import {fetchAccountSettings} from '../../setup/redux/accountSettingsThunk'

const MasterLayout: React.FC = ({children}) => {
  const dispatch = useDispatch()
  const localization: any = useSelector<RootState>(
    ({accountSetting}) => accountSetting.localization,
    shallowEqual
  )
  const hasLabels = !!localization?.ConnectLabel

  let accessToken = localStorage.getItem('acess-token')

  useEffect(() => {
    refreshPermissions()
  }, [accessToken])

  // Any localStorage.clear() (e.g. a failed token refresh) wipes the persisted labels without logging out, so reload them
  useEffect(() => {
    if (!hasLabels) dispatch(fetchAccountSettings())
  }, [hasLabels, dispatch])

  const refreshPermissions = async () => {
    let permissions = await PermissionsClient.ForCurrentUser()

    if (permissions && permissions.successful) {
      let mappedPermissions = permissions.data.data.map((p: any) => p.id)
      dispatch(auth.actions.setUserPermission(mappedPermissions))
    }
    
    let features = await AccountSettingsClient.GetFeatures()
    if (features && features.successful) {
      dispatch(auth.actions.setTenantFeatures(features.data.filter((a:any) => a.status === "enabled").map((f: any) => f.id)))
    }
  }

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />

          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            <Toolbar />
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>{children}</Content>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      {/* begin:: Drawers */}
      <ActivityDrawer />
      {/* <ExploreMain /> */}
      <DrawerMessenger />
      {/* end:: Drawers */}

      {/* begin:: Modals */}
      <Main />
      <InviteUsers />
      <UpgradePlan />
      {/* end:: Modals */}

      <MasterInit />
      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
